var __accessCheck = (obj, member, msg) => {
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
    __accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
    __accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value) : member.set(obj, value);
    return value;
};
var __privateMethod = (obj, member, method) => {
    __accessCheck(obj, member, "access private method");
    return method;
};

import {
    timeline as timeline11,
    animate as animate20,
    inView as inView14,
    scroll as scroll2,
    ScrollOffset,
} from "vendor";
import { EffectCarousel, matchesMediaQuery, mediaQueryListener, Modal } from "theme";

var _itemElements,
    _imageElements,
    _textElements,
    _visibleImageElement,
    _setupScrollObservers,
    setupScrollObservers_fn,
    _onBreakpointChanged,
    onBreakpointChanged_fn;
var uPimagesWithTextScroll = class extends EffectCarousel {
    constructor() {
        super(...arguments);
        /**
         * Setup the different observers for the desktop experience
         */
        __privateAdd(this, _setupScrollObservers);
        /**
         * Due to how different the experience is on mobile and desktop, we use an observer to toggle between one mode and other
         */
        __privateAdd(this, _onBreakpointChanged);
        __privateAdd(this, _itemElements, void 0);
        __privateAdd(this, _imageElements, void 0);
        __privateAdd(this, _textElements, void 0);
        __privateAdd(this, _visibleImageElement, void 0);

        this.$cardsWrapper = this.querySelector(".images-with-text-scroll__container");
        this.$cards = this.querySelectorAll(".images-with-text-scroll__item");

        this.numCards = this.$cards.length;

        this.$cards.forEach(($card, index0) => {
            const index = index0 + 1;
            const reverseIndex0 = this.numCards - index;

            const opacityArray = $card.classList.contains("up-no-bg-img")
                ? []
                : [1, reverseIndex0 == 0 ? 1 : -0.5];

            if( $card.classList.contains("up-no-bg-img")){
              $card.style.top = `calc(${this.numCards} * 0.75rem)`;
            }

            // Scroll-Linked Animation
            scroll2(
                animate20($card, {
                    scale: [1, 1 - 0.05 * reverseIndex0],
                    opacity: opacityArray,
                }),
                {
                    target: this.$cardsWrapper,
                    offset: [`${(index0 / this.numCards) * 100}%`, `${(index / this.numCards) * 100}%`],
                }
            );
        });
    }
    // Reference to the currently visible image elements
    connectedCallback() {
        super.connectedCallback();
        __privateSet(this, _itemElements, Array.from(this.querySelectorAll(".images-with-text-scroll__item")));
        __privateSet(this, _imageElements, Array.from(this.querySelectorAll(".images-with-text-scroll__image")));
        __privateSet(this, _textElements, Array.from(this.querySelectorAll(".images-with-text-scroll__text")));
        __privateSet(this, _visibleImageElement, __privateGet(this, _imageElements)[0]);
        inView14(this, () => {
            __privateGet(this, _imageElements).forEach((imageElement) => imageElement.setAttribute("loading", "eager"));
        });
        if (matchesMediaQuery("sm")) {
            __privateMethod(this, _setupScrollObservers, setupScrollObservers_fn).call(this);
        }
        mediaQueryListener("sm", __privateMethod(this, _onBreakpointChanged, onBreakpointChanged_fn).bind(this));
    }
};
_itemElements = new WeakMap();
_imageElements = new WeakMap();
_textElements = new WeakMap();
_visibleImageElement = new WeakMap();
_setupScrollObservers = new WeakSet();
setupScrollObservers_fn = function () {
    __privateGet(this, _textElements).forEach((textElement) => {
        scroll2(animate20(textElement, { opacity: [0, 0.25, 1, 0.25, 0] }), {
            target: textElement,
            offset: ScrollOffset.Any,
        });
    });
    scroll2(
        (info) => {
            const index = Math.min(
                    Math.floor(info.y.progress / (1 / __privateGet(this, _itemElements).length)),
                    __privateGet(this, _itemElements).length - 1
                ),
                toImage = __privateGet(this, _itemElements)[index].querySelector(".images-with-text-scroll__image");
            if (toImage && toImage !== __privateGet(this, _visibleImageElement)) {
                timeline11([
                    [__privateGet(this, _visibleImageElement), { opacity: [1, 0] }, { duration: 0.25 }],
                    [toImage, { opacity: [0, 1] }, { duration: 0.25, at: "<" }],
                ]);
                __privateSet(this, _visibleImageElement, toImage);
            }
        },
        { target: this, offset: ["start center", "end center"] }
    );
};
_onBreakpointChanged = new WeakSet();
onBreakpointChanged_fn = function (event) {
    if (event.matches) {
      this.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
        __privateGet(this, _imageElements).forEach((image) => (image.style = null));
        __privateGet(this, _textElements).forEach((text) => (text.style = null));
        __privateMethod(this, _setupScrollObservers, setupScrollObservers_fn).call(this);
    } else {
        this.getAnimations({ subtree: true }).forEach((animation) => animation.cancel());
    }
};
if (!window.customElements.get("up-images-with-text-scroll")) {
    window.customElements.define("up-images-with-text-scroll", uPimagesWithTextScroll);
}


var UpModalPassword = class extends Modal {
    constructor() {
        super();
        this.token = this.dataset["upToken"];
        this.upDisableEsckey = true;

        if(Shopify.designMode && this.dataset["upShowEditor"] == undefined) return;
        if (this.dataset["upMobileProse"] && matchesMediaQuery("x-sm-max")){
            this.querySelector(".prose").innerHTML = this.dataset["upMobileProse"];
            this.querySelector("form").style.display = "none";
            setTimeout(() => this.show(), 0);
        }

        if (!(localStorage.getItem(`theme:up-${this.id}`) === "true")) {
            this.querySelector("form").addEventListener("submit", this.onFormSubmit.bind(this));
            if(!this.open) setTimeout(() => this.show(), 0);
        }

        mediaQueryListener("x-sm-max", (event) => {
            if (event.matches){
                this.querySelector(".prose").innerHTML = this.dataset["upMobileProse"];
                this.querySelector("form").style.display = "none";
                if (!this.open && this.dataset["upMobileProse"]){
                    this.style.opacity = "1";
                    setTimeout(() => this.show(), 0);
                }
            }else{

                if (!(localStorage.getItem(`theme:up-${this.id}`) === "true")){
                    this.querySelector(".prose").innerHTML = this.dataset["upDesktopProse"];
                    this.querySelector("form").style.display = "grid";
                    
                }else{
                    if(this.open){
                        this.style.display = "none";
                        setTimeout(() => this.hide(), 0);
                    }
                }
            }  
        })
    }

    onFormSubmit(event) {
        event.preventDefault();
        this.upCurrentPassword = new FormData(event.srcElement).get("up-input-password");
        this.querySelectorAll('.banner').forEach((banner) => banner.style.display = "none");
        
        if(this.upCurrentPassword === this.token){
            localStorage.setItem(`theme:up-${this.id}`, 'true');
            this.querySelector('.banner--success').style.display = "block";
            setTimeout(() => this.shadowRoot.querySelector('[is="dialog-close-button"]').click(), 500);
            }else{
                this.querySelector('.banner--error').style.display = "block";
            }
    }

};

if (!window.customElements.get("up-x-modal-password")) {
    window.customElements.define("up-x-modal-password", UpModalPassword);
}

export { uPimagesWithTextScroll, UpModalPassword };